import { ActionIcon, Tooltip } from '@mantine/core';
import { HiOutlineInformationCircle } from 'react-icons/hi2';

type LogDetailInfoProps = {
  detailMessage: string;
};

const LogDetailInfo = ({ detailMessage }: LogDetailInfoProps) => {
  return (
    <Tooltip
      label={detailMessage}
      multiline
      maw={280}
      position="top-start"
      withArrow
      events={{ hover: true, focus: true, touch: false }}
      styles={{
        tooltip: {
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
        },
      }}
    >
      <ActionIcon aria-label="Log details" color="gray" size="xs" variant="subtle">
        <HiOutlineInformationCircle size={16} />
      </ActionIcon>
    </Tooltip>
  );
};

export default LogDetailInfo;
